import $ from "cash-dom";

export default class AudiolinkModule {

    static name = 'audiolink'

    constructor(node) {

        const name = $(node).data('name')
        const $item = $('.msp-playlist [data-name="'+ name +'"]').first()

        if(!$item.length) {
            console.log("Audiolink not found", name);
            $(node).remove()
            return;
        }
        const itemIndex = $item.index()
        const playlistId = $item.parent().attr('id')
        const playlistIndex = $('#playlists > li[data-source="'+ playlistId +'"]').index()

        $(node).on('click', function(e) {

            e.preventDefault()
            e.stopPropagation()
            
            if(playlistIndex === window.player1.data.prevId) {
                window.player1.playSpecificTrack(playlistIndex, itemIndex)
            } else {
                //if the playlist is not active, load it and then play
                window.player1.loadPlaylist(playlistIndex)
                window.player1.addListener(FWDMSP.LOAD_PLAYLIST_COMPLETE, () => {
                    window.player1.playSpecificTrack(playlistIndex, itemIndex)
                }, { once: true })
            }
        })
    }
}